'use client';

import React from 'react';
import { useUserStore } from './useUserStore';
import { createClient } from '@/utils/supabase/client';
import { useShallow } from 'zustand/shallow';

export default function UseUserStateStoreWrapper({
  children,
}: {
  children: React.ReactNode;
}) {

  useUserStore()

  return <>{children}</>;
}
